import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

export default ({ value, ...rest }: any) => {
  const { currentDateFormat } = useSelector((state: any) => state.common);

  return (
    <React.Fragment {...rest}>
      {dayjs(value)?.format(`${currentDateFormat}, HH:mm`)}
    </React.Fragment>
  );
};
